import { Message, MessageBox, Notification, Loading } from 'element-ui'
import i18n from '@/lang'

let loadingInstance;

// 标题和按钮原来是写死的中文，切成别的语言时这几个弹窗还是中文 呱呱~
const t = (key, fallback) => {
  const text = i18n.t(key)
  return text === key ? fallback : text
}
const title = () => t('common.info', '系统提示')
const boxOptions = (type) => ({
  confirmButtonText: t('common.confirm', '确定'),
  cancelButtonText: t('common.cancel', '取消'),
  customClass: 'sys-message-box',
  type
})

export default {
  // 消息提示
  msg(content) {
    Message.info(content)
  },
  // 错误消息
  msgError(content) {
    Message.error(content)
  },
  // 成功消息
  msgSuccess(content) {
    Message.success(content)
  },
  // 警告消息
  msgWarning(content) {
    Message.warning(content)
  },
  // 弹出提示
  alert(content) {
    MessageBox.alert(content, title(), { customClass: 'sys-message-box' })
  },
  // 错误提示
  alertError(content) {
    MessageBox.alert(content, title(), { type: 'error', customClass: 'sys-message-box' })
  },
  // 成功提示
  alertSuccess(content) {
    MessageBox.alert(content, title(), { type: 'success', customClass: 'sys-message-box' })
  },
  // 警告提示
  alertWarning(content) {
    MessageBox.alert(content, title(), { type: 'warning', customClass: 'sys-message-box' })
  },
  // 通知提示
  notify(content) {
    Notification.info(content)
  },
  // 错误通知
  notifyError(content) {
    Notification.error(content);
  },
  // 成功通知
  notifySuccess(content) {
    Notification.success(content)
  },
  // 警告通知
  notifyWarning(content) {
    Notification.warning(content)
  },
  // 确认窗体
  confirm(content) {
    return MessageBox.confirm(content, title(), boxOptions('warning'))
  },
  // 提交内容
  prompt(content) {
    return MessageBox.prompt(content, title(), boxOptions('warning'))
  },
  // 打开遮罩层
  loading(content) {
    loadingInstance = Loading.service({
      lock: true,
      text: content,
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    })
  },
  // 关闭遮罩层
  closeLoading() {
    loadingInstance.close();
  }
}
